import React, { memo, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { useAppContext } from "../../../../../../../../../context";
import { StyledRow } from "../../../../../../../../../components/common";
import { OrderFormProps } from "../../../types/FormProps";
import { Primary, Gray } from "../../styled";
import { ConstantFormat } from "../../../../../../../../../utils/DateFns";

const OrderDate: React.FC<OrderDate.Props> = ({ tab }) => {
	const { t } = useTranslation();
	const { dateFns } = useAppContext();

	const orderDate = useMemo(() => tab.form?.orderDate, [tab.form?.orderDate]);
	const filledAt = useMemo(() => tab.form?.filledAt, [tab.form?.filledAt]);
	const filled = useMemo(() => tab.form?.filled, [tab.form?.filled]);

	const status = useMemo(() => tab.form?.status, [tab.form?.status]);

	const created = useMemo(() => {
		if (orderDate && status && status !== "creating") {
			if (filled && filledAt) {
				const time = dateFns.formatTime2(
					filledAt,
					ConstantFormat.HMS_UK,
					{
						timezone: dateFns.timezone,
					},
				);
				const date = dateFns.formatTime2(
					filledAt,
					ConstantFormat.MDY_UK,
					{
						timezone: dateFns.timezone,
					},
				);
				return { time, date };
			}

			const time = dateFns.formatTime2(orderDate, ConstantFormat.HMS_UK, {
				timezone: dateFns.timezone,
			});
			const date = dateFns.formatTime2(orderDate, ConstantFormat.MDY_UK, {
				timezone: dateFns.timezone,
			});
			return { time, date };
		}
		return { time: "", date: "" };
	}, [dateFns, filled, filledAt, orderDate, status]);

	return (
		<StyledRow gap="0 6px">
			<Primary>
				{`${t([`orderPage.order_form.created`, "Created"])}:`}
			</Primary>
			<Gray>{created.date}</Gray>
			<Primary>{created.time}</Primary>
		</StyledRow>
	);
};

declare namespace OrderDate {
	interface Props extends OrderFormProps {}
}
export const OrderDateMemo = memo(OrderDate);
export default OrderDate;
